module.exports = __webpack_public_path__ + "img/fallen-cabbage.ba948424.png";